import { Fragment } from 'react'
import { TypeOptions } from 'react-toastify'
import BHTag from './BHTag'

interface BHTagListProps {
  className?: string
  tags: string | string[]
  status: TypeOptions
}

function BHTagList({ className, tags, status }: BHTagListProps) {
  let _tags: string | string[] = structuredClone(tags)
  if (typeof _tags === 'string') {
    _tags = [_tags]
  }

  _tags = _tags.filter((t) => t !== '')

  return (
    <div className={`flex flex-wrap flex-1 gap-1 ${className && className}`}>
      {_tags.map((tag) => (
        <BHTag key={tag} text={tag} status={status} />
      ))}
    </div>
  )
}

export default BHTagList
